<template>
  <section :class="$style.section">
    <ValidationObserver v-slot="{ valid }">
      <a-form :class="$style.form">
        <a-card v-if="isBroker" :title="$t('Wallet Info')">
          <p :class="$style.message">
            请提供您的 ERC20 USDT
            钱包地址，我们将于每个月的月初为您结算佣金，佣金将打到这个指定的钱包。
          </p>
          <a-row v-bind="formRowProps" :class="$style.row">
            <a-col :span="4">
              <a-form-item>
                钱包地址
              </a-form-item>
            </a-col>
            <a-col :span="14">
              <ValidationProvider
                mode="eager"
                :immediate="immediate"
                :name="$t('wallet_address')"
                rules="required|erc20_address"
                v-slot="slotProps"
              >
                <a-form-item
                  has-feedback
                  :validate-status="resolveState(slotProps)"
                  :help="slotProps.errors[0]"
                >
                  <a-input
                    v-model="wallet.address"
                    :size="$store.state.clientInfo.uiSize"
                    :class="$style.input"
                    placeholder="0x..."
                  />
                </a-form-item>
              </ValidationProvider>
            </a-col>
          </a-row>
          <a-row v-bind="formRowProps" :class="$style.row">
            <a-col :span="4">
              <a-form-item>
                钱包备注
              </a-form-item>
            </a-col>
            <a-col :span="14">
              <ValidationProvider
                mode="eager"
                :immediate="immediate"
                :name="$t('wallet_note')"
                rules="required"
                v-slot="slotProps"
              >
                <a-form-item
                  has-feedback
                  :validate-status="resolveState(slotProps)"
                  :help="slotProps.errors[0]"
                >
                  <a-input
                    v-model="wallet.note"
                    :size="$store.state.clientInfo.uiSize"
                    :class="$style.input"
                    placeholder='添加备注，让您不容易忘记。如"USDT_Binance"'
                  />
                </a-form-item>
              </ValidationProvider>
            </a-col>
          </a-row>
        </a-card>
        <a-card v-else :title="$t('Banking Info')">
          <h5>
            {{ $t("banking_info_subtitle") }}
          </h5>
          <p></p>
          <a-row v-bind="formRowProps">
            <a-col :span="8">
              <a-form-item>
                {{ $t("Currency") }}
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <ValidationProvider
                immediate
                :name="$t('Currency')"
                mode="eager"
                rules="required"
                v-slot="slotProps"
              >
                <a-form-item
                  has-feedback
                  :validate-status="resolveState(slotProps)"
                  :help="slotProps.errors[0]"
                >
                  <a-select
                    v-model="currency"
                    :size="$store.state.clientInfo.uiSize"
                    :placeholder="$t('Select Currency')"
                    :getPopupContainer="() => $root.$el"
                  >
                    <a-select-option
                      v-for="item in currencies"
                      :key="item.currency"
                    >
                      {{ item.currency }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </ValidationProvider>
            </a-col>
          </a-row>

          <a-row
            v-for="{ name, label, placeholder } in fields"
            v-bind="formRowProps"
            :key="name"
          >
            <a-col :span="8">
              <a-form-item>
                {{ $t(label) }}
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <ValidationProvider
                mode="eager"
                :immediate="immediate"
                :name="$t(name)"
                :rules="getRules(name)"
                v-slot="slotProps"
              >
                <a-form-item
                  has-feedback
                  :validate-status="resolveState(slotProps)"
                  :help="slotProps.errors[0]"
                >
                  <a-input
                    v-if="
                      name !== 'bank_country' && name.indexOf('address') < 0
                    "
                    v-model="parameters[name]"
                    :size="$store.state.clientInfo.uiSize"
                    :placeholder="$t(placeholder)"
                  />

                  <a-select
                    v-else-if="name === 'bank_country'"
                    showSearch
                    allowClear
                    v-model="parameters[name]"
                    :size="$store.state.clientInfo.uiSize"
                    :placeholder="$t(placeholder)"
                    :getPopupContainer="() => $root.$el"
                  >
                    <a-select-option
                      v-for="item in countryList"
                      :key="item[regionLangName]"
                    >
                      {{ item[regionLangName] }}
                    </a-select-option>
                  </a-select>

                  <validation-input-google-auto-complete
                    class="input-google-auto-complete"
                    v-else-if="name.indexOf('address') >= 0"
                    v-model="parameters[name]"
                    :placeholder="$t(placeholder)"
                    :isValid="slotProps.errors.length === 0"
                  >
                  </validation-input-google-auto-complete>
                </a-form-item>
              </ValidationProvider>
            </a-col>
          </a-row>

          <h4>{{ $t("Proof of Bank Account") }}</h4>
          <h5>
            {{ $t("bank_account_subtitle") }}
          </h5>
          <upload-files
            :size="uiSize"
            :file.sync="fileList4BankAccount"
            fileType="individual_banking"
          ></upload-files>
        </a-card>
      </a-form>
      <btm-step-nav-institution
        :passed="valid"
        :loading="isLoading"
        @submitForm="submitForm"
      ></btm-step-nav-institution>
    </ValidationObserver>
  </section>
</template>

<i18n>
{
  "en": {
    "Proof of Bank Account": "Proof of Bank Account(Optional)",
    "bank_account_subtitle": "A recent bank statement that includes your name and address will be a great help for us to verify your identity and speed up the account approval. You may cover the sensitive numbers if you have privacy concerns."
  },
  "zh": {
    "Proof of Bank Account": "银行账号证明（可选）",
    "bank_account_subtitle": "您有两个选择： 1. 提供近 1 个月银行对账单（Bank Statement，通常可以直接从网上银行下载为PDF文件）。对账单中包含有申请人姓名、地址和账号。 2. 提供网上银行清晰截屏。截屏中清晰显示银行名称，账户所有人名称（必须与申请人姓名一致），以及账号，以证明银行信息的真实性与准确性。如果您拥有多个不同银行账号，您可以在每笔交易时选择其中一个进行结算。"
  }
}
</i18n>

<script>
import { mapState } from "vuex";
import { withValidation } from "vee-validate";
import {
  Card,
  Form,
  Button,
  Input,
  Row,
  Col,
  Upload,
  Icon,
  Select
} from "ant-design-vue";
import BtmStepNavInstitution from "@/components/BtmStepNavIndividual";
import InputGoogleAutoComplete from "@/components/InputGoogleAutoComplete";
import UploadFiles from "@/components/UploadFiles";
import {
  getBankInfoByCurrency,
  setBankInfoByCurrency,
  getUserWallet,
  setUserWallet,
  queryKycRegion
} from "@/api/kyc";
import { displayErrors, getCountryList } from "@/utils";

const PREFIX_ORIGIN = "__origin-";

const ValidationInputGoogleAutoComplete = withValidation(
  InputGoogleAutoComplete
);

export default {
  name: "BankingInfo",
  data() {
    return {
      currency: "",
      fileList4BankAccount: [],
      isLoading: false,
      immediate: false,
      formRowProps: {
        gutter: 16,
        type: "flex",
        justify: "center",
        align: "middle"
      },
      fields: [],
      parameters: {},
      wallet: {
        address: "",
        note: ""
      },
      countryList: []
    };
  },
  props: {
    isBroker: {
      type: Boolean,
      default: false
    }
  },
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [Form.Item.name]: Form.Item,
    [Row.name]: Row,
    [Col.name]: Col,
    [Upload.name]: Upload,
    [Icon.name]: Icon,
    [Select.name]: Select,
    [Select.Option.name]: Select.Option,
    [Select.OptGroup.name]: Select.OptGroup,
    BtmStepNavInstitution,
    UploadFiles,
    ValidationInputGoogleAutoComplete
  },
  computed: {
    ...mapState({
      currencies: state => state.currencies,
      uiSize: state => state.clientInfo.uiSize
    }),
    regionLangName() {
      return "name_en";
    },
    langName() {
      return this.$i18n.locale === "zh" ? "CHS" : "ENG";
    },
    getLowRiskCountryList() {
      return getCountryList();
    },
    getRules() {
      return name => {
        if (
          this.parameters?.["bank_country"] === "United States" ||
          this.parameters?.["bank_country"] === "美国"
        ) {
          if (name === "bank_swift") {
            return "";
          } else {
            return "required";
          }
        } else {
          if (name === "rounting_number") {
            return "";
          } else {
            return "required";
          }
        }
      };
    }
  },
  watch: {
    async currency(val) {
      try {
        await this.getBankInfoByCurrency(val);
      } catch (err) {
        displayErrors(err);
      } finally {
        this.initRegionData();
      }
    }
  },
  methods: {
    resolveState({ errors, pending, valid }) {
      if (errors[0]) {
        return "error";
      }
      if (pending) {
        return "validating";
      }
      if (valid) {
        return "success";
      }
      return "";
    },
    setupFileList(type, name) {
      if (!name) return;

      this[`fileList4${type}`] = [
        { uid: `${PREFIX_ORIGIN}${Date.now()}`, name, status: "done" }
      ];
    },
    appendFileList(data, type, name) {
      this[`fileList4${type}`]
        .filter(({ uid }) => {
          if (uid) {
            return !uid.startsWith(PREFIX_ORIGIN);
          } else {
            return true;
          }
        })
        .forEach(({ file_path }) => {
          if (data instanceof FormData) {
            data.append(name, file_path);
          } else {
            data[name] = file_path;
          }
        });
    },
    async getUserWallet() {
      const { data } = await getUserWallet();
      if (Array.isArray(data) && data.length > 0) {
        this.wallet.address = data[0]?.address;
        this.wallet.note = data[0]?.note;
      }
    },
    async getBankInfoByCurrency(currency) {
      const {
        currency: remoteCurrency,
        // bank_file,
        bank_file_original_name,
        parameters: data,
        fields
      } = await getBankInfoByCurrency({ currency });
      this.currency = remoteCurrency;
      this.fields = fields;
      this.parameters = data || {};

      this.setupFileList("BankAccount", bank_file_original_name);
    },
    async setBankInfoByCurrency(currency) {
      const params = { currency, params: { ...this.parameters } };
      this.appendFileList(params, "BankAccount", "bank_file");

      await setBankInfoByCurrency(params);
    },
    async submitForm(callBack) {
      try {
        this.isLoading = true;
        if (this.isBroker) {
          await setUserWallet(this.wallet);
        } else {
          await this.setBankInfoByCurrency(this.currency);
        }
        callBack(true);
        this.isLoading = false;
      } catch (err) {
        callBack(false);
        displayErrors(err);
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        if (this.isBroker) {
          await this.getUserWallet();
        } else {
          await this.getBankInfoByCurrency(this.currency);
        }
      } catch (err) {
        displayErrors(err);
      }
    },
    async fetchRegions(parent_id = 0, prop = "countryList") {
      try {
        const result = await queryKycRegion({
          parent_id,
          allowed_user_type: "individual"
        });
        if (!result.errors) {
          this[prop] = result.data;
        } else {
          displayErrors(result);
        }
      } catch (err) {
        displayErrors(err);
      }
    },
    async initRegionData() {
      await this.fetchRegions();
      const existCountry = this.countryList.find(
        i => i[this.regionLangName] === this.country
      );
      if (existCountry) {
        await this.fetchRegions(existCountry.id, "provinceList");
      }
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style module lang="scss">
.message {
  text-align: center;
}
:global(.kyc_container) .section .form {
  .row {
    margin-bottom: 0.5em;
    .input,
    :global(.has-success) .input,
    :global(.has-error) .input {
      min-height: 40px;
    }
  }
}
</style>
